import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner, pageGifLoader } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function storeRoundTourFilters(list) {
    return {
        type: 'STORE_ROUND_TOUR_FILTERS',
        list: list.data
    }
}

export function getRoundTourFilters() {
    return function (dispatch) {
        dispatch(startLoading());
        // dispatch(pageGifLoader(true));
        fetch(API_URL + '/api/round-tours/filters', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    dispatch(storeRoundTourFilters(json));
                    if (json.success) {
                        dispatch(getRoundTourList("", "", "", "", json.data.max_cost));
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function stoteRoundTourDetailsUpdate(bool) {
    return {
        type: 'STORE_ROUND_TOUR_DETAILS_UPDATE', bool
    }
}

export function storeRoundTourList(list) {
    return {
        type: 'STORE_ROUND_TOUR_LISTS',
        list: list.data
    }
}

export function clearRoundTourList() {
    return { type: 'CLEAR_ROUND_TOUR_LISTS' }
}

export function getRoundTourList(search = "", cat = "", duration = "", rate = "", price = "") {
    return function (dispatch) {
        dispatch(pageGifLoader(true));
        dispatch(clearRoundTourList());
        fetch(API_URL + '/api/round-tours/list?key=' + search + "&category=" + cat + "&duration=" + duration + "&rating=" + rate + "&price_range=" + price, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(pageGifLoader(false));
                    if (json.success && json.data.tours.length > 0) {
                        dispatch(getRoundTourListMore(search, cat, duration, rate, price, json.data.tours[json.data.tours.length - 1].id, false));
                    }
                    dispatch(storeRoundTourList(json));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function updateRoundTourListArray(bool) {
    return {
        type: 'UPDATE_ROUND_TOUR_LIST_ARRAY', bool
    }
}


export function updateRoundTourList(data) {
    return {
        type: 'UPDATE_ROUND_MORE_TOUR_LISTS',
        list: data
    }
}

export function getRoundTourListMore(search = "", cat = "", duration = "", rate = "", price = "", id, loader = false) {
    return function (dispatch) {
        dispatch(updateRoundTourListArray(false));
        fetch(API_URL + '/api/round-tours/listMore?key=' + search + "&category=" + cat + "&duration=" + duration + "&rating=" + rate + "&price_range=" + price + "&id=" + id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            }
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(pageGifLoader(false));
                response.json().then((json) => {
                    dispatch(updateRoundTourListArray(json.success && json.data.tours.length > 0));
                    dispatch(updateRoundTourList(json.data));
                });
            }).catch((error) => {
                dispatch(pageGifLoader(false));
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}